export const MessagesUtil: Record<string, string> = {
  'MODEL_DISABLED_DUPLICATE': 'Unidad ya no disponible. No es posible realizar la duplicación.',
  'FINANCIAL_SETUP_INACTIVE': 'El paquete no está vigente.',
  'FINANCIAL_SETUP_COMPANY_MISMATCH':
    'El paquete financiero no está disponible para la compañía de esta cotización.',
}
